
import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { LoginService } from './login.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders,  
} from '@angular/common/http';
import { catchError, filter, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(private generalService:GeneralService, private authService:LoginService) { }
  intercept(req:HttpRequest<any>, next:HttpHandler): Observable<HttpEvent<any>>{

    const tokenInitial:string =  localStorage.getItem('Id-Token-Cognito') ?  localStorage.getItem('Id-Token-Cognito')! : '';
    const tokenId:string =  localStorage.getItem('Id-Token') ?  localStorage.getItem('Id-Token')! : '';
    const tokenRefresh:string = localStorage.getItem('Refresh-Token-Cognito') ? localStorage.getItem('Refresh-Token-Cognito')! : '';
    const tokenMotor:string = localStorage.getItem('Token-Motor') ? localStorage.getItem('Token-Motor')! :'';

    /* const tokenMotorNuevo:string = localStorage.getItem('Token-Motor') ? localStorage.getItem('Token-Motor')! :''; */
    let request = req;
    //let IdToken_Cognito = "IdToken-Cognito";
    //let RefeshToken_Cognito = "RefeshToken-Cognito"
    let data = {};
    
    if(!req.headers.get('skip')) {
      data = {
        headers:req.headers.set('Id-Token-Cognito',tokenInitial).set('Refresh-Token-Cognito', tokenRefresh).set('Token-Motor',tokenMotor).set('Sec_Fetch_Mode', 'no-cors')
      }
    } else {
      data = {
        headers: new HttpHeaders()
      }
    }

    let headers: any;
    if(!req.headers.get('direct')){
      headers = req.clone(data)
    } else{
      let http1 = this.distinctHeader(req);
      let data = {
        headers: http1
      }
      headers = req.clone(data);
      request = headers;
      headers = this.addTokenHeader(headers, tokenId);
    }

    return next.handle(headers)
      .pipe(
        catchError((error) => {
          
          if (error instanceof HttpErrorResponse) {
            return this.handleError401(request, next, error);
          } else {
            console.log(error, ' hola mundo');
            return throwError(() => error);
          }
        }));
    }

  addTokenHeader(req: HttpRequest<any>, token:any){
    //Clonamos el token y lo mandamos en la cabecera de todas las peticiones HTTP
    return req.clone({
      setHeaders: {
        Authorization : `Bearer ${ token }`,
      }
    });
  }

  handleError401(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse) {
    this.generalService.momentoFinal = new Date();

    let horaInicial = new Date(this.generalService.momentoInicial).getTime();
    let horaFinal = new Date(this.generalService.momentoFinal).getTime();

    let tiempoFinal = Math.round((horaFinal - horaInicial) / 60000);
    
    if(error.status == 401 && tiempoFinal <= 60) {
      return this.authService.refreshToken()
        .pipe(
          filter((response: any) => {
            return response.responseCode == 200
          }),
          switchMap((response: any) => {
            if (response?.responseCode != 200) {
              return throwError(() => error);
            } else {
              const tokenId:string =  localStorage.getItem('Id-Token') ?  localStorage.getItem('Id-Token')! : '';              
              return next.handle(this.addTokenHeader(request, tokenId));
            }
          })
        )
    } else {
      console.log(error, ' esto devuelve este vicio ');
      return throwError(() => error);
    }
  }

  distinctHeader(req: HttpRequest<any>):HttpHeaders{
    let headers2 = new HttpHeaders();
    req.headers.keys().forEach(key => {
      
      if(key != 'direct'){
        let info:any = req.headers.get(key)
        headers2.set(key, info);
      }
    });
    return headers2;
  }  

}
